export const advancedSearchUrl = ({ creditorId }) =>
  `/rental-notifications/${creditorId}/search`;
